import { Injectable } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Order, OrderHistoryFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrderDetailsService {
  orderCode$: Observable<string>;
  orderLoad$: Observable<{}>;
  orderNumber;

  constructor(private orderHistoryFacade: OrderHistoryFacade, private routingService: RoutingService) {
    // this.orderCode$ = this.routingService.getRouterState().pipe(
    //   map((routingData) => {
    //     return routingData.state?.params?.orderCode;
    //   }),
    //   distinctUntilChanged()
    // );
    this.orderCode$ = this.routingService.getRouterState().pipe(
      map(routerState => {
        const url = routerState.state.url;
        if (url.includes('/cwt-order')) {
          const segments = url.split('/');
          const orderIndex = segments.findIndex(segment => segment === 'cwt-order');
          if (orderIndex !== -1 && orderIndex < segments.length - 1) {
            return segments[orderIndex + 1];
          }
        }
        return null;
      }),
      distinctUntilChanged()
    );

    this.orderLoad$ = this.orderCode$.pipe(
      tap((orderCode) => {
        if (orderCode) {
          this.orderNumber = orderCode;
          this.orderHistoryFacade.loadOrderDetails(orderCode);
        } else {
          this.orderHistoryFacade.clearOrderDetails();
        }
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  getOrderDetails(): Observable<Order> {
    return this.orderLoad$.pipe(switchMap(() => this.orderHistoryFacade.getOrderDetails()));
  }
}
